import { useQuery } from '@tanstack/react-query'
import apiClient from '@/api/client'
import { resolveKitchenFlowGate, type KitchenFlowGate } from '@/hooks/useKitchenFlowEnabled'

/**
 * Staff & Payroll (F-HR-N1): backend env `FEATURE_HR_PAYROLL=1`, surfaced as
 * the server-injected `feature_hr_payroll` key on GET /settings. The sidebar
 * row and the page render only when this is exactly true; a missing key or
 * failed fetch reads as off. Same gate semantics and shared cache as the
 * kitchen flow and rider gates.
 */
export function useHRPayrollGate(): KitchenFlowGate {
  const { data, status, fetchStatus, refetch } = useQuery({
    queryKey: ['settings', 'all'],
    queryFn: () => apiClient.getAllSettings(),
    staleTime: Infinity,
  })
  const all = data?.data as Record<string, unknown> | undefined
  return {
    ...resolveKitchenFlowGate({ flag: all?.feature_hr_payroll, status, fetchStatus }),
    retry: () => void refetch(),
  }
}

export function useHRPayrollEnabled(): boolean {
  return useHRPayrollGate().enabled
}
